import * as dayjs from 'dayjs';

export default function (val, format = 'YYYY-MM-DD HH:mm:ss') {
  if (!val) return '--';
  if (!isNaN(val)) {
    val = +val;
  }
  return dayjs(val).format(format);
}
